import { Routes, Route, Link } from "react-router-dom";
import PageTracker from "./PageTracker.js";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import EventosAtivos from "./pages/EventosAtivos";
import EventoRouter from "./pages/EventoRouter";
import CadastroRouter from "./pages/CadastroRouter";
import EmBreve from "./pages/EmBreve";
import AdminLogin from "./pages/AdminLogin";
import AdminExportar from "./pages/AdminExportar";
import ConsultaCadastro from "./pages/ConsultaCadastro";
import TermoVisitante from "./pages/feinsul/TermoVisitante";
import TermoExpositor from "./pages/feinsul/TermoExpositor";

import "./styles/global.css";
import "./styles/home.css";
import "./styles/EmBreve.css";

export default function App() {
  return (
    <>
      <PageTracker />
      <ScrollToTop />

      <header className="header">
        <div className="logo-header-container">
          <img
            src="/imagens/LogoSchutzerTI.png"
            alt="Logo"
            className="logo-header"
          />
        </div>

        <nav className="menu">
          <Link to="/">Home</Link>
          <Link to="/eventos-ativos">Eventos Ativos</Link>
          <Link to="/em-breve">Em breve</Link>
        </nav>
      </header>

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/eventos-ativos" element={<EventosAtivos />} />
          <Route path="/evento/:id" element={<EventoRouter />} />
          <Route path="/evento/:id/:tipo" element={<CadastroRouter />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/admin-exportar" element={<AdminExportar />} />
          <Route path="/consulta-cadastro" element={<ConsultaCadastro />} />
          <Route path="/em-breve" element={<EmBreve />} />
          <Route path="/termo-visitante/:id" element={<TermoVisitante />} />
          <Route path="/termo-expositor/:id" element={<TermoExpositor />} />
        </Routes>
      </main>
    </>
  );
}